import React from 'react';

interface SubscriptionPlansCardProps {
  subscriptionStats: any;
  onEditPlan?: (plan: any) => void;
}

function planFlag(plan: any, apiName: string, legacyName: string): boolean {
  if (typeof plan[apiName] === 'boolean') return plan[apiName];
  return Boolean(plan[legacyName]);
}

export const SubscriptionPlansCard: React.FC<SubscriptionPlansCardProps> = ({
  subscriptionStats,
  onEditPlan,
}) => {
  if (!subscriptionStats?.plans) return null;

  return (
    <div className="card p-6 mb-8">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Available Subscription Plans</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {subscriptionStats.plans.map((plan: any) => (
          <div key={plan.id} className="border border-gray-200 rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <h4 className="font-medium text-gray-900">{plan.displayName || plan.name}</h4>
              <span
                className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                  plan.name === 'PROFESSIONAL'
                    ? 'bg-purple-100 text-purple-800'
                    : plan.name === 'STARTER'
                      ? 'bg-blue-100 text-blue-800'
                      : 'bg-gray-100 text-gray-800'
                }`}
              >
                {plan.name}
              </span>
            </div>
            <div className="space-y-1 text-sm text-gray-600">
              <p>Price: ${plan.priceMonthly}/month</p>
              <p>Max Sites: {plan.maxSites === -1 ? 'Unlimited' : plan.maxSites}</p>
              <p>Max Pages: {plan.maxPagesPerSite === -1 ? 'Unlimited' : plan.maxPagesPerSite}</p>
              <div className="mt-2 flex flex-wrap gap-1">
                {planFlag(plan, 'allowCustomDomain', 'customDomain') && (
                  <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                    Custom Domain
                  </span>
                )}
                {planFlag(plan, 'allowContactForms', 'contactForms') && (
                  <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                    Forms
                  </span>
                )}
                {planFlag(plan, 'allowAdvancedComponents', 'advancedComponents') && (
                  <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                    Advanced
                  </span>
                )}
                {planFlag(plan, 'allowCompeteStudio', 'competeStudio') && (
                  <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800">
                    Studio
                  </span>
                )}
              </div>
            </div>
            {onEditPlan && (
              <button
                type="button"
                className="btn-secondary mt-4 w-full"
                onClick={() => onEditPlan(plan)}
              >
                Edit
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
